<template>
  <!-- 最多支持6个评估关系 -->
  <yxt-tooltip
    :content="$t('pc_biz_eval_add_relation_maxsix')"
    placement="top"
    :disabled="!disabledFunc">
    <span>{{ label }}</span>
  </yxt-tooltip>
</template>

<script>
export default {
  props: {
    label: {
      type: String,
      default: ''
    },

    disabledFunc: {
      type: Boolean,
      default: false
    }
  }
};
</script>